import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, Spinner, Alert, Nav, Tab } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, sendOtpForLogin, validateLoginOtp } from '../actions/userActions';
import { useNavigate } from 'react-router-dom';

const LoginModal = ({ show, onHide, onOpenSignup }) => {
    const [userType, setUserType] = useState('interno');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [otp, setOtp] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, userInfo, error } = useSelector(state => state.user);
    const [isAppEnabled,setIsAppEnabled] = useState(true);
    const [isUserEnabled,setIsUserEnabled] = useState(true);

    useEffect(() => {
        if (userInfo && userInfo.Authenticated !== false) {
            navigate('/backoffice');
            onHide();
        }
    }, [userInfo, navigate, onHide]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (userType === 'interno') {
            dispatch(loginUser({ username, password }));
            return;
        }

        if (!showOtpInput) {
            try {
                await dispatch(sendOtpForLogin(username));
                setShowOtpInput(true);
            } catch (error) {
                setShowOtpInput(false);
            }
        } else {
            dispatch(validateLoginOtp({ Mail: username, Password: otp }));
        }
    };

    const resetForm = () => {
        setUsername('');
        setPassword('');
        setShowOtpInput(false);
        setOtp('');
        setUserType('interno');
    };

    const handleHide = () => {
        resetForm();
        onHide();
    };

    const handleUserTypeChange = (type) => {
        setUserType(type);
        setShowOtpInput(false);
        setOtp('');
        setPassword('');
    };
    
    return (
        <Modal show={show} onHide={handleHide} aria-labelledby="contained-modal-title-vcenter" centered className='modalLogin' id="ContainerLog">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className='iniciarSesion'>
                    INICIAR SESIÓN
                </Modal.Title>                
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : (
                    <div id="ContainerLogin">  
                        <Nav fill variant="tabs" className="mb-3 justify-content-center loginTabs" activeKey={userType} onSelect={handleUserTypeChange}>
                            <Nav.Item>
                                <Nav.Link eventKey="interno">Usuario UAI</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="externo">Usuario Externo</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        {userType === 'externo' && (
                            <Alert variant="secondary" className="mb-3">
                                <p>
                                    Se enviará una clave de acceso a su correo electrónico registrado. Ingrese su email y solicite la clave para iniciar sesión.
                                </p>
                                <hr />
                                <p className="mb-0">
                                    Si no recibe el correo, revise su carpeta de spam o intente nuevamente.
                                </p>
                            </Alert>
                        )}
                        {error && (
                            <Alert variant="danger" className="mb-4">
                                {error.replace(/<[^>]*>/g, '')}
                            </Alert>
                        )}
                        {isAppEnabled ? (
                            <Form onSubmit={handleSubmit} className="d-flex flex-column">
                                <Form.Group controlId="username" className="mb-3">
                                    <Form.Control 
                                        className='inputLogIn' 
                                        type="email" 
                                        placeholder="Email" 
                                        required
                                        value={username} 
                                        onChange={e => setUsername(e.target.value)} 
                                    />
                                </Form.Group>
                                {userType === 'interno' ? (
                                    <Form.Group controlId="password" className="mb-4">
                                        <Form.Control 
                                            className='inputLogIn' 
                                            type="password" 
                                            placeholder="Contraseña" 
                                            required
                                            value={password} 
                                            onChange={e => setPassword(e.target.value)} 
                                        />
                                    </Form.Group>
                                ) : showOtpInput ? (
                                    <Form.Group controlId="otp" className="mb-4">
                                        <Form.Control 
                                            className='inputLogIn' 
                                            type="text" 
                                            placeholder="Clave de Acceso" 
                                            required
                                            value={otp} 
                                            onChange={e => setOtp(e.target.value)} 
                                        />
                                    </Form.Group>
                                ) : null}
                                {!isUserEnabled && (
                                    <Alert variant="light" className="mb-3">
                                        La etapa de presentación de microcredenciales ha finalizado. La proxima fecha de presentación la informará la vicerrectoria académica.
                                    </Alert>
                                )}
                                <div className="d-block justify-content-center mt-3">
                                    <Button variant="primary" type="submit" id="ButtonLogin">
                                        {userType === 'interno' ? "Iniciar sesión" : showOtpInput ? "Validar" : "Solicitar clave"}
                                    </Button>
                                    {userType !== 'interno' && (
                                        <div className='d-flex mt-1 justify-content-center gap-2'>
                                            <p style={{color: '#575757'}}>¿No tenes cuenta?</p>
                                            <Button id='signup-link-modal' variant="link" onClick={() => { onOpenSignup(); }}>Registrate</Button>
                                        </div>
                                    )}
                                </div>
                            </Form>
                        ):(
                            <div>
                                <Alert variant="light ">
                                    <Alert.Heading>Informacion sobre UAI Microcredenciales</Alert.Heading>
                                    <p>
                                        La plataforma de presentación de microcredenciales se habilitará el <b>20 de diciembre de 2024</b>.
                                        Te esperamos a partir de esa fecha.<br/><br/> Gracias!
                                    </p>
                                </Alert>
                            </div>
                        )}             
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default LoginModal;
